<template>
  <div class="h-full">
    <Header
      title="Control Center"
      description="  Access all core features of your project in control center. Find
          options to manage content, accessbility, payments &amp; projects logs
          in this tab."
    />
    <EcommerceList />
  </div>
</template>
<script>
import EcommerceList from "./components/EcommerceList.vue";
import Header from "@/views/adminPanel/layouts/components/Header";
import NotificationUser from "@/views/adminPanel/pages/dashboard/NotificationUser";
export default {
  methods: {
    async getTags() {
      await this.$store.dispatch("tags/getTags");
    },
    async getDetailedCategory() {
      await this.$store.dispatch("EcomCategory/getDetailedCategory");
    },
  },
  components: {
    EcommerceList,
    Header,
    NotificationUser,
  },
  mounted() {
    this.getTags(), this.getDetailedCategory();
  },
};
</script>
